import Modifier from './modifier'

const Engine = {
  get: async function (raw, { ui, type = undefined, context = { } }) {
    await this._emit('get:start', { raw, type, context })
    if (type === 'field' || (raw.constructor !== String && Object.keys(raw).length > 1)) return raw
    if (Array.isArray(raw)) {
      const result = []
      for (const item in raw) result.push(await this.get(item, { ui, context }))
      return result
    }
    const modifierValue = await Modifier.calculate(this.modifiers, { raw, character: this, ui, type, context })
    const rawValue = await this.getRawValue({ raw, ui, type, context, fallback: raw })
    // TODO Handle special cases of addition like arrays and numbers according to the type
    const value = rawValue // + modifierValue
    await this._emit('get:over', { raw, value, type, context, rawValue, modifierValue })
    return value
  },

  execute: async function (raw='do nothing', ui, context = { }) {
    await this._emit('execution:start', { raw, ui, context })
    if (Array.isArray(raw)) {
      for (const item of raw)
        await this.execute(item, ui, context)
      return
    }

    const procedure = await this.getRawValue({ raw, ui, type: 'procedure', context, fallback: async () => await ui.output(raw) })
    if (typeof procedure === 'function') {
      await procedure({ character: this, raw, ui, context })
    } else {
      console.warn(`couldn't find procedure ${procedure}`)
    }
    await this._emit('execution:over', { raw, ui, context, value: procedure })
  },

  getRawValue: async function ({ raw, ui, type, context={}, fallback }) {
    if (context.hasOwnProperty(raw)) return context[raw]
    const matchingValuables = this.playbook.valuables.filter(v => v.match(raw, type))

    let value
    valuesearch: for (const valuable of matchingValuables) {
      value = await valuable?.getValue({ character: this, raw, ui, type, context })
      if (value !== undefined && value !== null)  break valuesearch
    }
    return this.getValueFromType((value === undefined ? (fallback === undefined ? raw : fallback) : value), type)
  },

  getValueFromType: function (raw, type) {
    if (!type || type === 'any')  return this.automaticlyType(raw)

    if (type.constructor === String) {
      if (type === 'array') return raw
      type = this.getType(type)
    }

    if (!type)  return raw

    return type.parseValue(raw)
  },

  automaticlyType: function (raw) {
    if (raw === undefined || raw === NaN)   return undefined
    if (Array.isArray(raw))                 return raw.map(item => this.getValueFromType(item))
    if (raw.constructor !== String)         return raw
    if (raw.match(/^\[.*\]$/))              return raw.substring(1, raw.length - 1).split(',').map(x => x.trim()).filter(x => x.length > 0)
    if (['true', 'yes'].includes(raw))      return true
    if (['false', 'no'].includes(raw))      return false
    if (isFinite(raw))                      return Number(raw)
    return raw
  },

  getType: function (name) {
    if (name.endsWith('array')) {
      const childType = this.getType(name.replace(/array$/).trim())
      return Type.Array(childType)
    }
    return this.playbook.rules.types.find(typeDefinition => typeDefinition.name === name)
  }
}

export default Engine
